/**
 * @generated SignedSource<<71f4cba4d5ff5d19cc6953c1ac8f750c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type verifyTempoTokenInput = {
  token?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type VerifyTempoTokenMutation$variables = {
  input: verifyTempoTokenInput;
};
export type VerifyTempoTokenMutation$data = {
  readonly verifyTempoToken: {
    readonly statusCode: number | null;
    readonly worklogCount: number | null;
  } | null;
};
export type VerifyTempoTokenMutation = {
  variables: VerifyTempoTokenMutation$variables;
  response: VerifyTempoTokenMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "verifyTempoTokenPayload",
    "kind": "LinkedField",
    "name": "verifyTempoToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "worklogCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b57e2e610c99f4831badfdf54e8c1665",
    "id": null,
    "metadata": {},
    "name": "VerifyTempoTokenMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyTempoTokenMutation(\n  $input: verifyTempoTokenInput!\n) {\n  verifyTempoToken(input: $input) {\n    statusCode\n    worklogCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a196231780f6b993d4605548940ee59";

export default node;
